
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import { postRequest, getRequest } from '@/plugins/api-axios'
import { getURL } from '@/utils/axios'
import { deserialise, serialise } from 'kitsu-core'

import ProjectUser from '@/views/Authorization/models/projectUser'

import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    inheritAttrs: false,
    name: 'ProjectUserInvitationDialog',
    components: {
        DialogTemplate,
    },
})
export default class ProjectUserInvitationDialog extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any
    valid = true
    get isValid() {
        return this.valid && (this.includeWebLink || this.includeAppLink)
    }

    loading = false
    hasError = false

    channel = null as null | string | undefined
    language = null
    includeWebLink = false
    includeAppLink = false
    invitationMessage = null as null | string

    @Watch('language', { immediate: true })
    async updateInvitationOnLangChange(newVal: any, oldVal: any) {
        if (!oldVal) {
            this.invitationMessage = this.$t(
                `authorization_fe['projectUserInvitation.dialog.invitationMessage.default']`,
                { projectName: this.currentProjectName }
            ).toString()
        } else {
            const data = await getRequest(
                getURL({
                    path: '/effectiveTexts',
                    base: process.env.VUE_APP_TRANSLATION_BASE_URL,
                    params: {
                        tags: 'message',
                        lang: this.language,
                    },
                }),
                {}
            )
            const translation =
                data.data['template-messages'][
                    'projectUserInvitation.dialog.invitationMessage.default'
                ]

            if (translation) {
                this.invitationMessage = translation.replace(/{(\w+)}/g, this.currentProjectName)
            } else {
                this.invitationMessage = this.$t(
                    `authorization_fe['projectUserInvitation.dialog.invitationMessage.default']`,
                    { projectName: this.currentProjectName }
                ).toString()
            }
        }
    }

    get projectUser(): ProjectUser {
        return this.props.projectUser
    }

    get channels() {
        return [
            {
                value: 'email',
                text: this.$t("authorization_enums['projectUserInvitations.channel.email']"),
                disabled: !this.projectUser['canSendInvitationEmail'],
            },
            {
                value: 'sms',
                text: this.$t("authorization_enums['projectUserInvitations.channel.sms']"),
                disabled: !this.projectUser['canSendInvitationSms'],
            },
        ]
    }

    get languages() {
        return this.languagesAvailableForUsers
    }

    async sendInvitation() {
        if (!this.isValid) return
        try {
            this.loading = true

            const payload = serialise('projectUserInvitation', {
                channel: this.channel,
                language: this.language,
                includeWebLink: this.includeWebLink,
                includeAppLink: this.includeAppLink,
                invitationMessage: this.invitationMessage,
                projectUser: {
                    data: {
                        type: this.projectUser['_type'],
                        id: this.projectUser['_id'],
                    },
                },
            })

            await postRequest(
                getURL({
                    path: '/projectUserInvitations',
                    base: process.env.VUE_APP_AUTHORIZATION_BASE_URL,
                }),
                {},

                payload.data
            )
            this.$emit('close', true)
        } catch (error) {
            this.hasError = true
        } finally {
            this.loading = false
        }
    }

    mounted() {
        this.channel = this.channels.find((chn) => !chn.disabled)?.value
        this.includeWebLink = this.channel == 'email' ? true : false
        this.includeAppLink = this.channel == 'sms' ? true : false
        this.language = this.userLanguage
    }
}
